import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable, OnDestroy } from '@angular/core';
import { Observable, Subject, throwError } from 'rxjs';
import { catchError, takeUntil } from 'rxjs/operators';
import { ConfigService } from './core/config.service';


@Injectable({
  providedIn: 'root',
})
export class UserEnseigneService implements OnDestroy {
  private readonly _destroying$ = new Subject<void>();

  constructor(private configService: ConfigService, private http: HttpClient) {}

  ngOnDestroy(): void {
    this._destroying$.next();
    this._destroying$.complete();
  }

  /**
   * Fetches enseignes by user email WITHOUT token.
   *
   * @param email - The user's email.
   * @returns Observable<string[]> - list of enseignes.
   */
  public fetchEnseignesByEmail(email: string): Observable<string[]> {
    const url = `${this.configService.config.backendUri}/UserEnseigne/${email}`;

    return this.http.get<string[]>(url).pipe(
      takeUntil(this._destroying$),
      catchError((error: HttpErrorResponse) => throwError(() => error))
    );
  }

  public fetchEmailsByEnseigne(enseigne: string): Observable<string[]> {
    const encoded = encodeURIComponent(enseigne);
    const url = `${this.configService.config.backendUri}/UserEnseigne/enseigne/${encoded}`;

    return this.http.get<string[]>(url).pipe(
      takeUntil(this._destroying$),
      catchError((error: HttpErrorResponse) => throwError(() => error))
    );
  }

}
